import React from 'react'
import ZoomIconOut from '../../../shared/ZoomIconOut'
import styles from './ZoomButton.module.scss'

export const mapZoomTextOut = window?.drupalSettings?.widgets?.mapZoom?.textZoomOut ?? ''

const ZoomButtonOut = (props) => (
  <div className={styles.zoomButtonOut} {...props}>
    <ZoomIconOut />
    <span className='wording-agrandir-ab'>
      {mapZoomTextOut}
    </span>
  </div>
)

export default ZoomButtonOut
